import { Badge } from 'antd'
import PropTypes from 'prop-types'

const StageNotify = ({ children }) =>
  !import.meta.env.VITE_IS_PROD ? (
    <Badge.Ribbon color="red" style={{ zIndex: 999 }} text="development">
      {children}
    </Badge.Ribbon>
  ) : (
    children
  )

StageNotify.propTypes = {
  children: PropTypes.node.isRequired,
}

export default StageNotify
